import { useContext } from "react";
import { Box, Button, Grid2 as Grid, IconButton, Paper, ThemeProvider, Typography} from "@mui/material";
import { getMuiTheme } from "../utilities/muiTheme";
import { rootContext } from "../contexts/rootContext";
import { useNavigate } from 'react-router';

type Props = {
  children: any
}

function PageTemplate({children}: Props) {
  const context = useContext(rootContext);
  const navigate = useNavigate();

  return (<Box 
    sx={{ 
      position: "relative",
      backgroundColor: "white",
      width: context.isScreenTooSmall ? "100vw" : "80vw",
      left: context.isScreenTooSmall ? "0" : "10vw",
      height: "100vh",
      "&::after": context.isScreenTooSmall ? {} : {
        filter: "blur(25px)",
        transform: "translate3d(0, 0, 0)",
        width: "105%",
        left: "-2.5%"
      },
      "&::after, &::before": context.isScreenTooSmall ? {} : {
        content: '""',
        position: 'absolute',
        top: "0",
        left: "0",
        bottom: "0",
        right: "0",
        background: `linear-gradient(
          45deg,
          #ba68c8,
          #42a5f5,
          #1976d2,
          #1565c0,
          #1976d2,
          #42a5f5,
          #ba68c8
        )`,
        backgroundSize: "400%",
        zIndex: "-1",
        animation: "glow 20s linear infinite",
        width: "100%"
      }
    }}
  >
    <Grid 
      container 
      spacing={0}
      alignContent="flex-start"
      sx={{ height: "100vh", overflowY: "scroll" }}
    >
      <Grid 
        container 
        spacing={0} 
        justifyContent="flex-start"
        sx={{padding: "0px", width: "100%", height: "60px"}}
      >
        <Paper 
          sx={{ 
            height: "100%",
            width: "100%",
            paddingTop: "5px",
            paddingRight: "10px", 
            paddingLeft: "10px",
            borderRadius: "0px"
          }}
        >
          <Button 
            onClick={()=>{navigate("/")}}
            sx={{ textTransform: "none"}} 
          >
            <img 
              src="/icons/icon-72x72.png"
              height="40px"
              width="40px"
            />
            <Typography variant="h4" sx={{color: "black", paddingLeft: "5px"}}>REal Recon</Typography>
          </Button>
        </Paper>
      </Grid>
      {children}
    </Grid>
  </Box>);
}

export default PageTemplate;
